import {defineStore} from 'pinia'

export const usePaymentProviderAccountStore = defineStore({
    id: 'payment_provider_account',
    state: () => ({
        payment_provider_accounts: [],
        payment_provider_account: null,
        itemLength: 0,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 10,
            sortBy: 'id',
            sortType: 'desc',
        }
    }),
    getters: {},
    actions: {
        index() {
            this.loading = true
            const params = {
                page: this.serverOptions.page + 1,
                size: this.serverOptions.rows
            }
            return this.apiClient.get('/payments/provider_accounts', {params}).then(({data}) => {
                this.payment_provider_accounts = data.payment_provider_accounts
                this.itemLength = data.payment_provider_accounts.length
                this.loading = false
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        show(id) {
            return this.apiClient.get(`/payments/provider_accounts/${id}`).then(({data}) => {
                this.payment_provider_account = data.payment_provider_account
                return {data}
            })
        },
        create(payment_provider_account) {
            return this.apiClient.post('/payments/provider_accounts', {payment_provider_account})
        },
        update(id, payment_provider_account, method = 'put') {
            return this.apiClient[method](`/payments/provider_accounts/${id}`, {payment_provider_account})
        },
    },
})
